/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type AccountNavContent_user = {
    readonly profile: {
        readonly email: string | null;
    } | null;
    readonly conversationSummary: {
        readonly unread: number | null;
    } | null;
    readonly " $refType": "AccountNavContent_user";
};
export type AccountNavContent_user$data = AccountNavContent_user;
export type AccountNavContent_user$key = {
    readonly " $data"?: AccountNavContent_user$data;
    readonly " $fragmentRefs": FragmentRefs<"AccountNavContent_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AccountNavContent_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Summary",
      "kind": "LinkedField",
      "name": "conversationSummary",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "unread",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '8997779c90abeb18372127fb77957faa';
export default node;
